import React from 'react'
import { Link } from 'react-router-dom'

const ErrorComponent = () => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <h1 className='text-center' style={{ fontSize: "5em" }}>404..!! 😫</h1>
                    <p className='text-center'>page you are lookingfor does not exist
                        <Link to="/">Go to Home</Link>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ErrorComponent